<template>
  <div>
    <div class="demo-image__preview">
      <el-image style="width: 295px; height: 466px" :src="url" :preview-src-list="srcList">
      </el-image>
    </div>
    <div class="version_confirm">
      <h3 class="version_comfirm_note">*请连接探头后上传以上软件界面以便确定软件版本的正确性</h3>
      <el-upload class="upload-demo"
                 action="https://remoteserver.storkhealthcare.cn/releaseReview/uploadImageForReleaseReview"
                 :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handleSuccess" :limit="1"
                 :on-exceed="handleExceed" list-type="picture" :file-list="fileList" drag>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
      </el-upload>
    </div>
  </div>
</template>

<script>
import Global from "../Global";

export default {
  name: "ReleaseReviewVersionConfirm",
  data() {
    return {
      fileList: [],
      version_confirm: '',
      url: require('../../assets/version_confirm.png'),
      srcList: [
        require('../../assets/version_confirm.png')
      ]
    }
  },
  watch: {
    version_confirm() {
      this.sendVersionData();
    }
  },
  methods: {
    // 输入框内容改变的时候发送给父组件
    sendVersionData() {
      this.$emit('getVersionData', this.version_confirm);
    },
    // 上传图片成功以后调用这个函数
    handleSuccess(res, file) {
      // 得到确认图片的Url
      if (res.code == 200) {
        this.fileList.push(res.data);
        this.version_confirm = res.data.url;
      } else {
        this.$message.error(res.data);
      }
    },
    // 文件列表移除某个文件时候回调这个函数
    handleRemove(file, fileList) {
      // 将确认图片置空
      this.version_confirm = '';
      // 在服务器中删除这个文件
      let that = this;
      that.axios({
        method: 'POST',
        url: Global.accountUrl + '/releaseReview/deleteImageForReleaseReview?url=' + file.url
      }).then(function (response) {
        if (response.data.code != 200) {
          that.$message.error(response.data.data);
        }
      });
    },
    // 当文件被移除之前调用这个函数
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 当上传文件超出指定个数的时候调用这个函数
    handleExceed(file, fileList) {
      this.$message.warning('每个条目最多上传1个图片');
    },
  }
}
</script>

<style scoped>
  .version_comfirm_note {
    text-align: center;
    color: red;
  }

  .upload-demo {
    text-align: center;
  }

  p {
    text-align: center;
  }

  .version_confirm {
    max-width: 600px;
    margin: 25px auto;
  }

  .demo-image__preview {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/release_review/ReleaseReviewVersionConfirm.vue